
// M010 video teaser
function initVideoteaser() {

    if ($(".videoTeaser").length > 0) {
        $(".videoTeaser").each(function () {

            var $videoTeaser = $(this);
            var $videoPlayer = $(this).find("iframe");

            $videoTeaser.find(".videoTeaserPreview").first().addClass("active");

            $(this).find(".playButton").each(function () {
                var previewsource = "http://img.youtube.com/vi/" + $(this).attr("video-source") + "/0.jpg";
                $(this).parent("div").css("background-image", "url(" + previewsource + ")");
                $(this).siblings("iframe").hide();
            });

            //add click events
            $(this).find(".playButton").click(function () {
                $videoPlayer.attr("src", "https://www.youtube.com/embed/" + $(this).attr("video-source") + "?modestbranding=0&controls=1&showinfo=0&rel=0&fs=1&color=white&autoplay=1");
                $videoTeaser.find(".videoTeaserTitle").html($(this).attr("video-title"));
                $videoPlayer.show();

                $videoTeaser.find(".videoTeaserVideoButton").hide();

                $videoTeaser.find(".videoTeaserPreview").removeClass("active");
                $(this).closest(".videoTeaserPreview").addClass("active");
            });
            $(this).find(".playButton").on("keydown", handleKeyDownForClick);

            $(this).find(".videoTeaserPreview").click(function () {
                $videoPlayer.attr("src", "https://www.youtube.com/embed/" + $(this).children(".playButton").attr("video-source") + "?modestbranding=0&controls=1&showinfo=0&rel=0&fs=1&color=white&autoplay=1");
                $videoTeaser.find(".videoTeaserTitle").html($(this).children(".playButton").attr("video-title"));
                $videoPlayer.show();

                $videoTeaser.find(".videoTeaserVideoButton").hide();

                $videoTeaser.find(".videoTeaserPreview").removeClass("active");
                $(this).addClass("active");
            });
            $(this).find(".videoTeaserPreview").on("keydown", handleKeyDownForClick);

            //load first video in player iframe
            var $actPB = $(this).find(".playButton").first();
            $videoPlayer.attr("src", "https://www.youtube.com/embed/" + $actPB.attr("video-source") + "?modestbranding=0&controls=1&showinfo=0&rel=0&fs=1&color=white");
            $videoTeaser.find(".videoTeaserTitle").html($actPB.attr("video-title"));
        });
    }

}